import {
  GroupFileField,
  useSubdomainInfo,
} from 'LoggedOut/SignUp/useSubdomainInfo';
import getSubdomainFromUrl from 'utils/getSubdomainFromUrl';
import { AuthTypeEnum } from '__generated__/globalTypes';
import { RegistrationMethod } from '../constants';

export const useGetRegistrationMethods = (): {
  registrationMethods: RegistrationMethod[];
  loading: boolean;
} => {
  const registrationMethods: RegistrationMethod[] = [];

  const {
    group,
    groupFileFields,
    loading = true,
  } = useSubdomainInfo({
    subdomain: getSubdomainFromUrl(),
  }) || {};

  const { authType } = group || {};

  if (!authType) {
    return {
      registrationMethods,
      loading,
    };
  }

  if (
    authType === AuthTypeEnum.AUTH0_SSO ||
    authType === AuthTypeEnum.MIXED_MODE
  ) {
    registrationMethods.push(RegistrationMethod.SSO);
  }

  if (
    authType === AuthTypeEnum.LEGACY_CREDENTIALS ||
    authType === AuthTypeEnum.MIXED_MODE
  ) {
    const employeeIds =
      groupFileFields?.filter(
        (groupFileField): groupFileField is GroupFileField =>
          !!groupFileField && groupFileField.fileMappingField !== 'email',
      ) || [];

    if (employeeIds.length > 0) {
      registrationMethods.push(RegistrationMethod.CLOSED_EMPLOYEE_ID);
    } else {
      registrationMethods.push(RegistrationMethod.OPEN_EMAIL);
    }
  }

  return {
    registrationMethods,
    loading,
  };
};
